"use client";

import React from "react";
import { TrendingUp, Sparkles, Award } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Priority Booking",
  description: "Secure immediate vehicle dispatch and guaranteed availability for your high-stakes executive transfers and airport arrivals.",
  icon: TrendingUp
}, {
  title: "Monthly Invoicing",
  description: "Simplify corporate accounting with consolidated billing, detailed trip logs, and flexible payment terms for your organization.",
  icon: Sparkles
}, {
  title: "Dedicated Concierge",
  description: "Access a 24/7 account manager to oversee every detail of your itinerary, from SFO landings to multi-stop schedules.",
  icon: Award
}];
export default function WhyPartnersChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="131843" id="executive-account-benefits" className="relative py-24 md:py-32 bg-background dark overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none mix-blend-soft-light" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} aria-hidden="true" />

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-serif text-foreground tracking-tight mb-6 uppercase">
            Executive Account Benefits
          </h2>
          <p className="text-lg font-sans text-muted-foreground leading-relaxed">
            Empower your corporate logistics with GoldSteer's bespoke executive accounts, designed for the unique pace and discretion of the San Francisco Bay Area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={i} data-index={i} className="border-t border-primary/20 shadow-xl bg-card hover:bg-secondary transition-all duration-500 flex flex-col items-center text-center px-8 py-12 rounded-sm group">
                <div className="mb-8 p-4 rounded-full bg-secondary/50 group-hover:bg-primary/10 transition-colors duration-500">
                  <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} aria-hidden="true" />
                </div>
                <h3 className="text-2xl font-serif text-foreground mb-4">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground font-sans leading-relaxed">
                  {benefit.description}
                </p>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}